import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-[#020008] pt-32 pb-16 px-4 border-t border-white/5">
      <div className="max-w-7xl mx-auto text-center">
        <div className="mb-20">
          <h2 className="text-4xl md:text-5xl font-black mb-10 text-white uppercase tracking-tighter">Join the Ascension.</h2>
          <div className="flex flex-wrap justify-center gap-6">
            <a 
              href="https://twitter.com/dai_kho_limited" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-8 py-4 glass-panel rounded-2xl hover:bg-white/10 transition-all group border-white/5"
            >
              <SafeIcon name="Twitter" className="text-cyan-400 w-6 h-6" />
              <span className="font-bold uppercase tracking-widest text-sm text-slate-300">@dai_kho_limited</span>
            </a>
            <a 
              href="#" 
              className="flex items-center gap-3 px-8 py-4 glass-panel rounded-2xl hover:bg-white/10 transition-all group border-white/5"
            >
              <SafeIcon name="MessageCircle" className="text-purple-400 w-6 h-6" />
              <div className="text-left">
                <span className="block font-bold uppercase tracking-widest text-sm text-slate-300">Telegram</span>
                <span className="block text-[10px] text-slate-500 font-bold">@DaiKhoToken Crypto Info Group</span>
              </div>
            </a>
          </div>
        </div>

        <div className="p-10 rounded-[2.5rem] bg-red-950/10 border border-red-900/20 mb-20 max-w-4xl mx-auto">
          <p className="text-red-400 font-bold uppercase tracking-widest text-xs mb-4">Risk Disclaimer</p>
          <p className="text-slate-500 text-sm leading-relaxed">
            DaiKhoToken (DKT) is a utility digital asset. Trading cryptocurrencies involves significant risk. 
            DKT does not guarantee returns and is intended for long-term participation within the DAI KHO LIMITED ecosystem.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pt-12 border-t border-white/5">
          <div className="flex items-center gap-4">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/53257d18d934c13deb15172e6d977d0c36a3dd097c5c5cf609cb857dac040a3963b23aa6d7b2ab716a4b1aba01045119/images/aW1hZ2UvcG5n/86073368fa597368b31df5a13528b417.png" 
              alt="DaiKhoToken Logo" 
              className="w-16 md:w-20 h-auto object-contain invert" 
            />
            <div className="text-left">
              <p className="text-white font-black text-xl tracking-tighter">DAIKHO TOKEN</p>
              <p className="text-slate-600 text-xs font-mono">Issuer: cryptogod444</p>
            </div>
          </div>
          
          <div className="text-center md:text-left">
            <p className="text-white font-bold text-sm mb-1 uppercase tracking-widest">Contact Support</p>
            <p className="text-slate-400 font-mono text-xs">
              daikholimited@gmail.com / 512-228-0573
            </p>
          </div>

          <p className="text-slate-600 text-sm tracking-tighter font-medium underline decoration-white/10 underline-offset-4">
            &copy;2026 DaiKhoToken. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;